import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/images/arscp_logo_black.png'
import _imports_1 from '@/images/arscp_logo_white.png'
import _imports_2 from '@/images/menu.svg'
import _imports_3 from '@/images/menu-white.svg'


const _hoisted_1 = {
  href: "#",
  target: "_blank"
}
const _hoisted_2 = {
  src: _imports_0,
  class: "h-9",
  alt: "logo"
}
const _hoisted_3 = {
  src: _imports_1,
  class: "h-9",
  alt: "logo"
}
const _hoisted_4 = { class: "md:hidden block navbarList" }
const _hoisted_5 = {
  key: 0,
  src: _imports_2,
  class: "w-6 h-6",
  alt: "menu"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_3,
  class: "w-6 h-6",
  alt: "menu"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "fixed w-full top-16 left-0 p-4 z-10" }
const _hoisted_9 = { class: "bg-scp-white rounded-xl text-scp-purple w-full h-max flex flex-col items-center justify-center p-4" }

import { checkParentsHas } from '@/libs'
import { ref, onMounted, nextTick, computed } from 'vue'
import Mask from './Mask.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const isNavberItemVisible = ref(false)
const isNavbarItemList = checkParentsHas('navbarList')
const toDomPage = (id:string) => {
  if (window.innerWidth <= 765) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'auto' })
  } else {
    if (id === 'portfolio') {
      scrollTo(0, document.body.scrollHeight - 750)
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'auto' })
    }
  }
  nextTick(() => {
    setTimeout(() => {
      scrollBy(0, -2)
      scrollBy(0, 2)
    }, 50)
  })
  isNavberItemVisible.value = false
}
const toAboutUs = (id:string) => {
  const bannerHeight = document.getElementById(id)?.clientHeight ?? 0
  scrollTo(0, bannerHeight)
  nextTick(() => {
    setTimeout(() => {
      scrollBy(0, 5)
    }, 50)
  })
  isNavberItemVisible.value = false
}
const featureBoxTop = ref(document.getElementById('featureBox')?.getBoundingClientRect().top ?? 0)
const portfolioTop = ref(document.getElementById('portfolio')?.getBoundingClientRect().top ?? 0)
const isNavbarBg = computed(() => {
  return featureBoxTop.value > 100 || portfolioTop.value <= 0
})
onMounted(() => {
  document.addEventListener('click', (e) => {
    if (!isNavbarItemList(e.target as HTMLElement)) {
      isNavberItemVisible.value = false
    }
  })
  window.addEventListener('scroll', () => {
    featureBoxTop.value = document.getElementById('featureBox')?.getBoundingClientRect().top ?? 0
    portfolioTop.value = document.getElementById('portfolio')?.getBoundingClientRect().top ?? 0
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(isNavbarBg) ? 'bg-white' : 'bg-black bg-opacity-15', "w-full transition-all duration-500 z-20 flex items-center justify-between md:h-100px h-16 md:px-16 px-4 fixed top-0 left-0"])
  }, [
    _createElementVNode("a", _hoisted_1, [
      _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
        [_vShow, _unref(isNavbarBg)]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
        [_vShow, !_unref(isNavbarBg)]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["text-base leading-none font-Roboto-Medium md:block hidden", _unref(isNavbarBg) ? 'text-scp-black' : 'text-white'])
    }, [
      _createElementVNode("div", {
        class: "hover:text-scp-purple inline-block cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toAboutUs('home')))
      }, " About Us "),
      _createElementVNode("div", {
        class: "mx-20 hover:text-scp-purple inline-block cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toDomPage('portfolio')))
      }, " Portfolio "),
      _createElementVNode("div", {
        class: "hover:text-scp-purple inline-block cursor-pointer",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toDomPage('footer')))
      }, " Contact Us ")
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass([`${isNavberItemVisible.value ? 'border-opacity-100' : ''}
        ${_unref(isNavbarBg) ? 'border-scp-black' : 'border-white' }`, "border w-8 h-8 flex items-center justify-center cursor-pointer border-opacity-45 rounded-md hover:border-opacity-100 active:border-opacity-100"]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (isNavberItemVisible.value = !isNavberItemVisible.value))
      }, [
        (_unref(isNavbarBg))
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : (_openBlock(), _createElementBlock("img", _hoisted_6))
      ], 2),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (isNavberItemVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(Mask, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (isNavberItemVisible.value = false))
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "navberItem",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (toAboutUs('home')))
                    }, " About Us "),
                    _createElementVNode("div", {
                      class: "my-2 navberItem",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (toDomPage('portfolio')))
                    }, " Portfolio "),
                    _createElementVNode("div", {
                      class: "navberItem",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (toDomPage('footer')))
                    }, " Contact Us ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})